// Funciones
import { ROUTES } from "../../../../../const/routes";

/**
 * Assts de la caja del tragamonedas
 * @param {*} scene 
 */
export function cargaAssetsCajaTragamonedas(scene) {
  scene.load.image(
    "cajaTragamonedas",
    ROUTES.rutaTragamonedasCajaTragamonedas + "/cajaTragamonedas1Resized.png"
  );
}
